























import { Component, Prop, Vue } from 'vue-property-decorator';

import { Product, Show } from '@/store/modules/lib';
import { Getter, State, namespace } from 'vuex-class';

const auth = namespace('auth');
const event = namespace('event');

@Component
export default class ShProductGroup extends Vue {

  @auth.Getter('showId') protected showId: any;
  @auth.Getter('shows') protected shows: any;

  protected get showColor() {

    let show: Show = this.shows.filter((s: Show) => s._id == this.showId)[0];

    return show && show.color ? `#${show.color}` : '#AD2131';

  }

  protected get showStyle() {

    return {
      'background-color': this.showColor
    };

  }

  // @Prop({ type: String, default: "" }) protected title!: string;
  // @Prop({ type: Array, default: [] }) protected products!: Product[];

  // protected productSelected(productId: string) {
  //   this.$emit('productSelected', productId);
  // }

  // protected productRemove(productId: string) {
  //   this.$emit('productRemove', productId);
  // }

  // protected productEdit(productId: string) {
  //   this.$emit('productEdit', productId);
  // }

  // protected get sortedProducts() {

  //   return this.products.sort(function(a: Product, b: Product) {
  //     return a.title > b.title
  //       ? 1
  //       : (a.title < b.title)
  //         ? -1
  //         : 0;
  //   });

  // }

}

